module.exports = __webpack_public_path__ + "static/media/evolution-gaming.40bbfce7.webp";